import { render, staticRenderFns } from "./ClaimCoupon.vue?vue&type=template&id=07c28738&scoped=true&"
import script from "./ClaimCoupon.vue?vue&type=script&lang=js&"
export * from "./ClaimCoupon.vue?vue&type=script&lang=js&"
import style0 from "./ClaimCoupon.vue?vue&type=style&index=0&id=07c28738&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c28738",
  null
  
)

export default component.exports